<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Promotion links</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_LANDING_PAGE_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add link</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control" placeholder="Filter by name" style="padding: 11px;">

      <app-dropdown-select class="form-control" [(ngModel)]="filters.values['productId']" (onDropdownChange)="filters.onFilterChange()" placeholder="Filter by brand" [multiple]="true">
        @for (product of products; track product) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select class="form-control" [(ngModel)]="filters.values['lang']" (onDropdownChange)="filters.onFilterChange()" placeholder="Filter by lang" [multiple]="true">
        @for (lang of languages; track lang) {
          <app-dropdown-select-option [value]="lang.isoCode">{{ lang.name }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['typeId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by type" class="form-control">
        @for (type of types; track type.id) {
          <app-dropdown-select-option [value]="type.id">{{ type }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['userId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by author" class="form-control">
        @for (user of users; track user.id) {
          <app-dropdown-select-option [value]="user.id">
            {{ user }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select class="form-control" [(ngModel)]="filters.values['external']" (onDropdownChange)="filters.onFilterChange()" placeholder="Filter by type">
        <app-dropdown-select-option [value]="null">All</app-dropdown-select-option>
        <app-dropdown-select-option [value]="false">Internal</app-dropdown-select-option>
        <app-dropdown-select-option [value]="true">External</app-dropdown-select-option>
      </app-dropdown-select>

      <app-dropdown-select class="form-control" [(ngModel)]="filters.values['activeSince']" (onDropdownChange)="filters.onFilterChange()" placeholder="Filter by activity">
        <app-dropdown-select-option [value]="''">All</app-dropdown-select-option>
        @for (period of activityPeriods; track period.identifier) {
          <app-dropdown-select-option [value]="period.identifier">{{ period.label }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="name">Name</th>
          <th tableSorterHeader="type">Type</th>
          <th>Offers</th>
          <th>Site</th>
          <th>Url</th>
          <th>Created</th>
          <th>Modified</th>
          <th>Author</th>
          <th tableSorterHeader="external">Scope</th>
          <th tableSorterHeader="enabled">Status</th>
          <th class="text-end">Action</th>
        </tr>
        </thead>
        <tbody>
          @for (landingPage of landingPages; track landingPage) {
            <tr>
              <td>{{ landingPage.id }}</td>
              <td>{{ landingPage.name }}</td>
              <td>{{ landingPage.type }}</td>
              <td>
                <app-collapser [maxItems]="1">
                  @for (offerId of landingPage.offers; track offerId) {
                    <app-collapser-item>
                      {{ getOfferNameById(offerId) }}
                    </app-collapser-item>
                  }
                </app-collapser>
              </td>
              <td>
                {{ landingPage.site?.name }}
              </td>
              <td>
                <a [href]="landingPage.url" target="_blank">
                  {{ landingPage.getShortUrl() }}
                </a>
              </td>
              <td>{{ landingPage.createdAt | date:'dd MMM yyyy' }}</td>
              <td>{{ landingPage.updatedAt | date:'dd MMM yyyy' }}</td>
              <td>{{ landingPage.user }}</td>
              <td>
                @if (landingPage.external) {
                  <span class="badge bg-secondary">External</span>
                }
                @if (!landingPage.external) {
                  <span class="badge bg-primary">Internal</span>
                }
              </td>
              <td>
                @if (landingPage.enabled) {
                  <span class="badge bg-success">Enabled</span>
                }
                @if (!landingPage.enabled) {
                  <span class="badge bg-danger">Disabled</span>
                }
              </td>
              <td class="text-end">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[landingPage.id]"><i
                  class="bi bi-pencil me-1"></i>Edit
                </a>
                <a class="btn btn-outline-secondary btn-sm ms-1" [routerLink]="['/stats/detailed']"
                  [queryParams]="{landingPageId: landingPage.id}" title="Detailed statistics"><i
                  class="bi bi-bar-chart"></i>
                </a>
                <button class="btn btn-outline-secondary btn-sm ms-1" appConfirm (click)="duplicate(landingPage)">
                  <i class="bi bi-copy me-1"></i>Duplicate
                </button>
                <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(landingPage)"><i
                  class="bi bi-trash"></i></button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
